import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    frame: String
  }

  getFormValues() {
    const formValues = {}
    this.inputTargets.forEach(input => {
      const inputName = input.name
      const match = inputName.match(/\[(.*?)\]/)
      if (match) {
        const fieldName = match[1] // Esto extraerá 'date' de 'booking_form[date]'
        formValues[fieldName] = input.value
      }
    })
    return formValues
  }

  navigate(event) {
    const formAction = event.target.form.action

    const existingUrl = new URL(formAction)
    const existingParams = new URLSearchParams(existingUrl.search)

    const newParams = new URLSearchParams(this.getFormValues())

    // Merge existing and new params
    for (const [key, value] of newParams) {
      existingParams.set(key, value)
    }

    const url = existingUrl.pathname + "?" + existingParams.toString()

    Turbo.visit(url, { frame: this.frameValue })
  }
} 
